import React from 'react'
import { connect } from 'react-redux'
import { setDSWizard, getBrokerInfo } from 'state/actions'
import DSWizard from './DSWizard'
import nesProp from 'nested-property'
import styles from './DSWizardHelper.scss'
import cs from 'classnames'
import underscore from 'underscore'
import i18n from 'lib/i18n'
import * as c from 'state/constants'

// variables out of module
const _ = i18n('mifidButton')

/**
 * This module render a button witch can be used to open DSDocument wizard
 */
@connect(
    state => ({
        DSWizardOpened: state.DSDocuments.DSWizardOpened,
        moduleKey: state.DSDocuments.moduleKey,
        lang: state.app.lang,
        currentModule: state.app.module,
        openedMifidKey: state.DSDocuments.openedMifidKey,
    })
)
export default class MifidButton extends React.Component {
    static propTypes = {
        callBackOnClose: React.PropTypes.func,
        callBackOnCloseClaimWizard: React.PropTypes.func,
        moduleKeyToSet: React.PropTypes.string,
        subModuleKeyToSet: React.PropTypes.string,
        isResume: React.PropTypes.bool,
        packageId: React.PropTypes.string,

        clientId: React.PropTypes.string,
        contractId: React.PropTypes.string,
        claimId: React.PropTypes.string,

        tarificationId: React.PropTypes.string,
        tarificationNumber: React.PropTypes.string,

        lang: React.PropTypes.string,
        disabled: React.PropTypes.bool,

        forceGetClient: React.PropTypes.bool,
        hideButton: React.PropTypes.bool,
        buttonText: React.PropTypes.string,

        customModalTitle1: React.PropTypes.string,
        customModalTitle2: React.PropTypes.string,
        customModalTitle3: React.PropTypes.string,
        customModalDescriptionStep1: React.PropTypes.string,
        customModalDescriptionStep2: React.PropTypes.string,
        customModalDescriptionStep3: React.PropTypes.string,
        stakeholders: React.PropTypes.array,
        moduleOptions: React.PropTypes.object,
        alienUserId: React.PropTypes.string,

        ticketId: React.PropTypes.string,
        ticketDocuments: React.PropTypes.array,
        selectedTicketDocuments: React.PropTypes.array,
        emailAttachmentTicketDocuments: React.PropTypes.array,
        openTrigger: React.PropTypes.bool,
        onlyIcon: React.PropTypes.bool,
        mifidKey: React.PropTypes.string,
        brokerFromOffice: React.PropTypes.object,
    }

    constructor(props) {
        super(props)
        const brokerFromOffice = props.brokerFromOffice
        this.state = {
            brokerFromOffice
        }
    }

    /**
     * This function fired when the module attached
     */
    async componentDidMount() {
        const { disabled, moduleKeyToSet, currentModule, ticketDocuments, brokerFromOffice, moduleOptions, dispatch } = this.props
        if (!disabled && (moduleKeyToSet === c.DS_MODULE_CLIENT_CONTRACT_PREM || ticketDocuments) && currentModule !== 'DSDOCUMENTS') {
            this.openDSWizardModal()
        }

        if (moduleKeyToSet === c.DS_MODULE_OFFICE && !brokerFromOffice && moduleOptions.brokerNumber) {
            const getBrokerInfoRes = await dispatch(getBrokerInfo(moduleOptions.brokerNumber))
            this.setState({ brokerFromOffice: getBrokerInfoRes })
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.openTrigger !== nextProps.openTrigger && nextProps.openTrigger) {
            this.openDSWizardModal()
        }

        if (nextProps.brokerFromOffice !== this.props.brokerFromOffice) {
            this.setState({
                brokerFromOffice: nextProps.brokerFromOffice
            })
        }
    }

    /**
     * This function helps to use an icon on a safe way
     */
    getIcon = menuName => {
        try {
            return require(`resources/images/icn-${menuName}.svg`)
        } catch (err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }

    /**
     * This function will open a modal for DSWizard.
     */
    openDSWizardModal(e = null) {
        const { dispatch, moduleKeyToSet, mifidKey } = this.props

        // preventing click if existing event found
        if (e) {
            e.preventDefault()
        }

        // set physical module for package, make sure that have value, and that is valid for the mifid wizard
        let moduleKeyForPackage = ''
        switch (moduleKeyToSet) {
            case c.DS_MODULE_CLIENT_PROFILE: {
                moduleKeyForPackage = c.DS_MODULE_CLIENT_PROFILE
                break;
            }
            case c.DS_MODULE_CLIENT_CONTRACT: {
                moduleKeyForPackage = c.DS_MODULE_CLIENT_CONTRACT
                break;
            }
            case c.DS_MODULE_CLIENT_CONTRACT_PREM: {
                moduleKeyForPackage = c.DS_MODULE_CLIENT_CONTRACT_PREM
                break;
            }
            case c.DS_MODULE_CLIENT_CLAIMS: {
                moduleKeyForPackage = c.DS_MODULE_CLIENT_CLAIMS
                break;
            }
            case c.DS_MODULE_CLIENT_TARIFICATION: {
                moduleKeyForPackage = c.DS_MODULE_CLIENT_TARIFICATION
                break;
            }
            case c.DS_MODULE_OFFICE: {
                moduleKeyForPackage = c.DS_MODULE_OFFICE
                break;
            }
            case c.DS_MODULE_CLAIM_WIZARD: {
                moduleKeyForPackage = c.DS_MODULE_CLAIM_WIZARD
                break;
            }
            default: {
                moduleKeyForPackage = c.DS_MODULE_CLIENT_PROFILE
            }
        }

        dispatch(setDSWizard(true, moduleKeyForPackage, mifidKey))
    }

    /**
     * OnClose event of ds wizard.
     */
    onCloseDSWizard(clientId, entityId) {
        const { callBackOnClose } = this.props
        callBackOnClose(clientId, entityId)
    }

    onCloseDSWizardFromClaimWizard(packageId) {
        const { callBackOnCloseClaimWizard } = this.props
        if (underscore.isFunction(callBackOnCloseClaimWizard)) {
            callBackOnCloseClaimWizard(packageId)
        }
    }

    /**
     * Main render function
     */
    render() {
        const { DSWizardOpened, moduleOptions, lang, packageId, clientId, contractId, claimId, isResume, disabled, forceGetClient,
            hideButton, tarificationId, tarificationNumber, buttonText, customModalTitle1, customModalDescriptionStep1, onlyIcon,
            customModalTitle2, customModalDescriptionStep2, customModalTitle3, customModalDescriptionStep3, subModuleKeyToSet, openedMifidKey, mifidKey,
            stakeholders, alienUserId, ticketId, ticketDocuments, selectedTicketDocuments, emailAttachmentTicketDocuments, claimNumber, claimWizardDocType } = this.props
        const { brokerFromOffice } = this.state
        let buttonLabel = isResume ? _('resumeToEdit') : _('mifidButtonLabel')

        // if there is set the property on react element "buttonText", then overwrite the original functionality
        if (buttonText) {
            buttonLabel = buttonText
        }

        return (
            <div className={cs(styles.mifidButtonContainer, onlyIcon ? styles.onlyIcon : '')} key={"mifidButton"}>
                {!hideButton &&
                    <div
                        key={"btnMifid"}
                        className={cs((onlyIcon ? styles.onlyIcon : styles.grayButtonFlex), (onlyIcon ? styles.onlyIcon : styles.mifidButton), (disabled ? styles.disabled : ''))}
                        onClick={(e) => (!disabled ? this.openDSWizardModal(e) : e.preventDefault())}
                    >
                        <img className={cs(onlyIcon ? styles.mifidNoMarginIcon : styles.mifidButtonIcon)} src={onlyIcon ? this.getIcon('dsdocuments-blue') : this.getIcon('dsdocuments-white')} /> {onlyIcon ? '' : buttonLabel}
                    </div>}
                {DSWizardOpened && (!openedMifidKey || openedMifidKey === mifidKey) &&
                    <DSWizard
                        step={c.DSWIZARD_STEP_1_COMPOSE_PACKAGE}
                        subModuleKey={subModuleKeyToSet}
                        packageId={packageId}
                        clientId={clientId}
                        contractId={contractId}
                        claimId={claimId}
                        claimNumber={claimNumber}
                        tarificationId={tarificationId}
                        tarificationNumber={tarificationNumber}
                        lang={lang}
                        callBackOnClose={(clientId, entityId) => { this.onCloseDSWizard(clientId, entityId) }}
                        callBackOnCloseFromClaimWizard={(packageId) => { this.onCloseDSWizardFromClaimWizard(packageId) }}
                        forceGetClient={forceGetClient}
                        customModalTitle1={customModalTitle1}
                        customModalTitle2={customModalTitle2}
                        customModalTitle3={customModalTitle3}
                        customModalDescriptionStep1={customModalDescriptionStep1}
                        customModalDescriptionStep2={customModalDescriptionStep2}
                        customModalDescriptionStep3={customModalDescriptionStep3}
                        stakeholders={stakeholders}
                        moduleOptions={moduleOptions}
                        alienUserId={alienUserId}
                        ticketId={ticketId}
                        ticketDocuments={ticketDocuments}
                        selectedTicketDocuments={selectedTicketDocuments}
                        emailAttachmentTicketDocuments={emailAttachmentTicketDocuments}
                        brokerFromOffice={brokerFromOffice}
                        claimWizardDocType={claimWizardDocType}
                    />}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/mifidButton.jsx